import { TableActions } from "../../../components/tables/tableContext/TableContext";

import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { fetchDrivers } from "../../../redux/api/transport.api";
import {
  assignedDriversDataTableHeader,
  getAssignedDriversTableData,
} from "./components/tableConfigs/assignedDriversTableConfig";

import AssignActionButton from "./components/TableActionsButtonsComponents/AssignDriverActionButton";
import TableWidget from "../../../components/tables/TableWidget";
import { transportRoutes } from "../../../router/routesConstants";
import FormHeader from "../../../components/misc/FormHeader";

function AssignDrivers() {
  const dispatch = useAppDispatch();

  const {
    transport: {
      assignedDriversData: {
        data: { data: assignedDriversData, total },
        isLoading: isLoadingAssign,
      },
    },
  } = useAppSelector((state) => ({
    transport: state.transport,
  }));

  const handleTableActions = (action: TableActions) => {
    if (
      action.tablePagination.page &&
      action.tablePagination.rowsPerPage &&
      action.tableSearch &&
      action.tableFilter
    ) {
      dispatch(
        fetchDrivers({
          page: action.tablePagination.page,
          perPage: action.tablePagination.rowsPerPage,
          nume: action.tableSearch.nume,
          prenume: action.tableSearch.prenume,
          type: action.tableFilter.type,
          nrauto: action.tableSearch.nrauto,
        }),
      );
    }
  };

  return (
    <TableWidget
      CustomHeaderComponent={() => (
        <FormHeader
          title="Alocare rute"
          buttonRoute={transportRoutes.assignDriver}
          buttonIcon="ADD"
          tooltipTitle="Adauga sofer"
        />
      )}
      tableHeaderData={assignedDriversDataTableHeader}
      tableItemsData={getAssignedDriversTableData(assignedDriversData)}
      totalItems={total}
      borderedRow
      tableLoading={isLoadingAssign}
      ActionButtonsComponent={AssignActionButton}
      handleTableActions={handleTableActions}
    />
  );
}

export default AssignDrivers;
